<template>
  <div class="flex justify-between space-x-3">
    <div
      id="chart"
      :style="{ backGround: bg_line }"
      class="w-2/3 rounded shadow-xs pt-1"
    >
      <apexchart
        type="area"
        class="w-11/12 mx-auto"
        height="240"
        :options="todayOptions"
        :series="todaySeries"
      ></apexchart>
    </div>

    <div
      id="chart"
      :style="{ backGround: bg_line }"
      class="w-1/3 rounded shadow-xs pt-1"
    >
      <apexchart
        type="area"
        class="w-11/12 mx-auto"
        height="240"
        :options="yesterOptions"
        :series="yesterSeries"
      ></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  name: "LineCharts",

  props: {
    todayData: Object,
    yesterdayData: Object,
    bg_line: String,
    bg_text: String,
  },

  data() {
    const startToday = this.moment()
      .startOf("day")
      .format("x");

    const yesterStart = this.moment()
      .subtract(1, "day")
      .startOf("day")
      .format("x");
    return {
      todaySeries: [
        {
          name: "Success",
          data: this.todayData.success,
        },
        {
          name: "Failed",
          data: this.todayData.failed,
        },
      ],
      todayOptions: {
        chart: {
          type: "area",
          foreColor: "#7777bb",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        fill: {
          type: "solid",
          opacity: 0.5,
        },
        colors: ["#02B80A", "#FF333F"],
        markers: {
          size: 1,
          strokeColors: ["#004d00", "#b3000c"],
        },
        xaxis: {
          type: "datetime",
          // min: Number(startToday),
          tickAmount: 6,
        },
        yaxis: {
          labels: {
            formatter: (val) => "₦" + val,
          },
        },
        tooltip: {
          x: {
            format: "dd/MM/yy h:mm tt",
          },
        },
        title: {
          text: "Transactions for Today",
          floating: false,
          style: {
            fontSize: "13px",
            fontWeight: "normal",
            color: this.bg_text,
          },
        },
      },

      yesterSeries: [
        {
          name: "Success",
          data: this.yesterdayData.success,
        },
        {
          name: "Failed",
          data: this.yesterdayData.failed,
        },
      ],
      yesterOptions: {
        chart: {
          type: "area",
          foreColor: "#7777bb",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        fill: {
          type: "solid",
          opacity: 0.5,
        },
        colors: ["#02B80A", "#FF333F"],
        markers: {
          size: 1,
          strokeColors: ["#004d00", "#b3000c"],
        },
        xaxis: {
          type: "datetime",
          // min: Number(yesterStart), //removes one day
          tickAmount: 6,
        },
        yaxis: {
          labels: {
            formatter: (val) => "₦" + val,
          },
        },
        tooltip: {
          x: {
            format: "dd/MM/yy h:mm tt",
          },
        },
        title: {
          text: "Transactions for Yesterday",
          floating: false,
          style: {
            fontSize: "13px",
            fontWeight: "normal",
            color: this.bg_text,
          },
        },
      },
    };
  },
};
</script>
